import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { ILanguageList } from "../types";

export type ILanguageListQueryParameters = IPaginateable;

export type ILanguageListQueryResult = ILanguageList;

export const languageListQuery: IApiQueryFunction<ILanguageListQueryParameters> = ({ pagination }) => {
    return {
        method: "GET",
        url: `/languages${serialize(
            {
                ...mapPagination(pagination),
            },
            true,
        )}`,
    };
};

export const useLanguageListQuery = createApiQueryHook<ILanguageListQueryParameters, ILanguageListQueryResult>(
    languageListQuery,
);
